function initLikhaanInteractions() {
    const PROXY_URL = '/apps/social';
    const CUSTOMER_ID = window['LikhaanCustomerId'];

    // --- Modal Logic using Event Delegation ---
    document.body.addEventListener('click', (e) => {
        const target = /** @type {Element} */ (e.target);
        if (!target || !target.closest) return;

        // 1. Open Modal
        const card = target.closest('.likhaan-post-card');
        if (card && !target.closest('button, a, .likhaan-post-interactions')) {
            const postId = card.getAttribute('data-post-id');
            console.log('Clicked post card. Post ID:', postId);
            
            const modalId = `LikhaanModal-${postId}`;
            const modal = document.getElementById(modalId);
            console.log('Looking for modal with ID:', modalId, 'Found:', modal ? 'Yes' : 'No');
            
            if (modal) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
            } else {
                console.error('Modal not found in DOM!');
            }
            return;
        }

        // 2. Close Modal via Close Button
        const closeBtn = target.closest('.likhaan-modal-close');
        if (closeBtn) {
            const modal = closeBtn.closest('.likhaan-modal-overlay');
            if (modal) {
                modal.classList.remove('active');
                document.body.style.overflow = '';
            }
            return;
        }

        // 3. Close Modal via Overlay Click
        if (target.classList.contains('likhaan-modal-overlay')) {
            target.classList.remove('active');
            document.body.style.overflow = '';
            return;
        }

        // 4. Toggle Save Dropdown
        const saveBtn = target.closest('.likhaan-save-btn');
        if (saveBtn) {
            const dropdown = saveBtn.nextElementSibling;
            if (dropdown && dropdown.classList.contains('likhaan-save-dropdown')) {
                const isActive = dropdown.classList.contains('active');
                // Close all other dropdowns
                document.querySelectorAll('.likhaan-save-dropdown.active').forEach(d => d.classList.remove('active'));
                
                if (!isActive) {
                    dropdown.classList.add('active');
                }
            }
            return;
        }

        // 5. Close Save Dropdowns if clicked outside
        if (!target.closest('.likhaan-save-dropdown')) {
            document.querySelectorAll('.likhaan-save-dropdown.active').forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }

        // 6. Open Create Collection Modal
        const openCreateBtn = target.closest('.likhaan-open-new-collection-btn');
        if (openCreateBtn) {
            const modalId = openCreateBtn.getAttribute('data-modal');
            if (modalId) {
                const createModal = document.getElementById(modalId);
                if (createModal) {
                    // close the save dropdown first
                    document.querySelectorAll('.likhaan-save-dropdown.active').forEach(d => d.classList.remove('active'));
                    createModal.classList.add('active');
                }
            }
            return;
        }

        // 7. Close Create Collection Modal via Overlay Click
        if (target.classList.contains('likhaan-create-collection-modal-overlay')) {
            target.classList.remove('active');
            return;
        }
    });

    // --- Carousel Logic ---
    const carousels = document.querySelectorAll('.likhaan-media-carousel');
    carousels.forEach(carousel => {
        const slides = carousel.querySelectorAll('.likhaan-carousel-slide');
        const prevBtn = carousel.querySelector('.likhaan-carousel-prev');
        const nextBtn = carousel.querySelector('.likhaan-carousel-next');
        let currentIndex = 0;

        if (!prevBtn || !nextBtn || slides.length <= 1) return;

        const showSlide = (index) => {
            slides.forEach(s => s.classList.remove('active'));
            slides[index].classList.add('active');
        };

        prevBtn.addEventListener('click', () => {
            currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
            showSlide(currentIndex);
        });

        nextBtn.addEventListener('click', () => {
            currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
            showSlide(currentIndex);
        });
    });

    // --- Share Logic ---
    const shareBtns = document.querySelectorAll('.likhaan-share-btn');
    shareBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const url = btn.getAttribute('data-url');
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: 'Likhaan Post',
                        url: url
                    });
                } catch (err) {
                    console.log('Error sharing:', err);
                }
            } else {
                navigator.clipboard.writeText(url).then(() => {
                    alert('Link copied to clipboard!');
                });
            }
        });
    });

    // --- Helper function for API ---
    async function apiRequest(action, data) {
        if (!CUSTOMER_ID) {
            alert("Please log in to perform this action.");
            return null;
        }
        
        try {
            const response = await fetch(PROXY_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: action,
                    customerId: CUSTOMER_ID,
                    ...data
                })
            });
            
            const textRaw = await response.text();
            let json;
            try {
                json = JSON.parse(textRaw);
            } catch (e) {
                console.error(`Received non-JSON response (${response.status}):\n`, textRaw);
                alert(`Server responded with an error (${response.status}):\n${textRaw.substring(0, 100)}`);
                return null;
            }
            
            if (!response.ok) {
                console.error("API Error:", json);
            }
            return json;
        } catch (error) {
            console.error(`Network/Fetch error in ${action}:`, error);
            alert(`A network error occurred: ${error.message}`);
            return null;
        }
    }

    // --- Like Logic ---
    const likeBtns = document.querySelectorAll('.likhaan-like-btn');
    likeBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-id');
            const countSpan = btn.querySelector('.likhaan-likes-count');
            
            // Optimistic UI updates
            const isLiked = btn.classList.contains('liked');
            let currentCount = parseInt(countSpan ? countSpan.textContent || '0' : '0') || 0;
            
            if (isLiked) {
                btn.classList.remove('liked');
                if (countSpan) countSpan.textContent = String(Math.max(0, currentCount - 1));
            } else {
                btn.classList.add('liked');
                if (countSpan) countSpan.textContent = String(currentCount + 1);
            }

            const result = await apiRequest('like_post', { postId });
            if (result && result.success !== undefined) {
                // Confirm server state
                if (result.isLiked) {
                    btn.classList.add('liked');
                } else {
                    btn.classList.remove('liked');
                }
                if (countSpan) countSpan.textContent = String(result.likesCount);
            } else {
                // Revert if error
                if (isLiked) {
                    btn.classList.add('liked');
                    if (countSpan) countSpan.textContent = String(currentCount);
                } else {
                    btn.classList.remove('liked');
                    if (countSpan) countSpan.textContent = String(currentCount);
                }
            }
        });
    });

    // --- Comment Logic ---
    const commentSubmitBtns = document.querySelectorAll('.likhaan-comment-submit-btn');
    commentSubmitBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-post-id');
            const input = /** @type {HTMLTextAreaElement|null} */ (document.getElementById(`CommentInput-${postId}`));
            if (!input) return;
            const content = input.value.trim();
            const list = document.getElementById(`CommentsList-${postId}`);

            if (!content || !list) return;

            const submitBtn = /** @type {HTMLButtonElement} */ (btn);
            submitBtn.disabled = true;
            submitBtn.textContent = 'Posting...';

            const result = await apiRequest('add_comment', { postId, content });
            
            if (result && !result.errors && !result.userErrors?.length) {
                // Append locally
                const noCommentsMsg = list.querySelector('.likhaan-no-comments');
                if (noCommentsMsg) noCommentsMsg.remove();

                const newComment = document.createElement('div');
                newComment.className = 'likhaan-comment';
                newComment.innerHTML = `
                    <div class="likhaan-comment-author"><strong>You</strong>:</div>
                    <div class="likhaan-comment-content">${content.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</div>
                `;
                list.appendChild(newComment);
                input.value = '';
            } else {
                alert('Failed to post comment. Please try again.');
            }

            submitBtn.disabled = false;
            submitBtn.textContent = 'Post';
        });
    });

    /**
     * Helper function to show Toast
     * @param {string} postId
     * @param {string} message
     */
    function showToast(postId, message) {
        const toast = document.getElementById(`LikhaanToast-${postId}`);
        if (!toast) return;
        toast.textContent = message;
        toast.classList.add('show');
        setTimeout(() => {
            toast.classList.remove('show');
        }, 3000);
    }

    // --- Create Collection Logic ---
    const submitCreateBtns = document.querySelectorAll('.likhaan-submit-create-collection-btn');
    submitCreateBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-post-id');
            const input = /** @type {HTMLInputElement|null} */ (document.getElementById(`CreateCollectionInput-${postId}`));
            if (!input) return;
            const title = input.value.trim();
            const list = document.getElementById(`CollectionsList-${postId}`);

            if (!title || !list) return;
            
            const submitBtn = /** @type {HTMLButtonElement} */ (btn);
            const originalText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Creating...';

            const result = await apiRequest('create_collection', { title });
            
            if (result && result.data?.metaobjectCreate?.metaobject) {
                const newId = result.data.metaobjectCreate.metaobject.id;
                
                // Immediately save to the newly created collection
                const saveRes = await apiRequest('save_to_collection', { collectionId: newId, postId });
                
                // Remove loading text if it's there
                const loadingTxt = list.querySelector('.likhaan-collections-loading');
                if (loadingTxt) loadingTxt.remove();

                const newItem = document.createElement('div');
                newItem.className = 'likhaan-collection-item';
                newItem.setAttribute('data-id', newId);
                newItem.textContent = title;
                list.appendChild(newItem);
                input.value = '';
                
                // Close the create collection modal
                const modal = document.getElementById(`CreateCollectionModal-${postId}`);
                if (modal) modal.classList.remove('active');
                
                if (saveRes && saveRes.data && !saveRes.data.metaobjectUpdate.userErrors.length) {
                    showToast(postId, `Saved to '${title}'`);
                } else if (saveRes && saveRes.success) { // Fallback for simple success response
                    showToast(postId, `Saved to '${title}'`);
                }
            } else {
                alert('Failed to create collection.');
            }
            
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        });
    });

    // Save to existing collection logic
    const saveDropdowns = document.querySelectorAll('.likhaan-save-dropdown');
    saveDropdowns.forEach(dropdown => {
        const list = dropdown.querySelector('.likhaan-collections-list');
        const postId = dropdown.id.replace('SaveDropdown-', '');
        
        list?.addEventListener('click', async (e) => {
            const target = /** @type {HTMLElement} */ (e.target);
            if (target && target.classList && target.classList.contains('likhaan-collection-item')) {
                const collectionId = target.getAttribute('data-id');
                
                const origText = target.textContent || '';
                target.textContent = 'Saving...';
                
                const saveRes = await apiRequest('save_to_collection', { collectionId, postId });
                
                if (saveRes && !saveRes.errors) {
                    target.textContent = 'Saved ✓';
                    showToast(postId, `Saved to '${origText.replace('Saving...','').trim()}'`);
                    setTimeout(() => {
                        target.textContent = origText;
                    }, 2000);
                } else {
                    target.textContent = 'Failed';
                }
            }
        });
    });

}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLikhaanInteractions);
} else {
    initLikhaanInteractions();
}
